/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthResetPasswordRequest, AuthResetPasswordResponse } from '../types/AuthResetPassword'

/**
 * POST /auth/reset-password
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::resetPassword
 */
export async function authResetPassword(
	data: AuthResetPasswordRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthResetPasswordResponse>> {
	return axiosInstance.post('/auth/reset-password', data, config)
}
